<template>
    <a-modal :title="state.modalTitle + `线索记录`" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <a-button type="primary" @click="handleChat">去聊天</a-button>
            <a-divider type="vertical" />
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item label="步骤" name="step">
                    <a-select v-model:value="formData.step" placeholder="请选择">
                        <a-select-option :value="1">线索</a-select-option>
                        <a-select-option :value="2">待办</a-select-option>
                        <a-select-option :value="3">办理中</a-select-option>
                        <a-select-option :value="4">已办结</a-select-option>
                        <a-select-option :value="5">已废弃</a-select-option>
                        <a-select-option :value="6">公共池</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="备注">
                    <a-textarea v-model:value="formData.record" :rows="2" placeholder="请输入内容"></a-textarea>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-modal>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref } from 'vue'
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    }
})
interface IState {
    loading: boolean
    modalTitle: string
    submitLoading: boolean
}
const state = reactive<IState>({
    loading: false,
    modalTitle: '新增',
    submitLoading: false,
})
interface IformData {
    step: number
    record: string
}
const formData = reactive<IformData>({
    step: 1,
    record: '',
})
onMounted(() => {
    if (props.detailData?.id) {
        state.modalTitle = '编辑'
        queryDetail()
    }
})
const queryDetail = () => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/xiansuoRecord/${props.detailData.id}/edit`,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            Object.assign(formData, res.data)
        })
        .finally(() => {
            state.loading = false
        })
}

// 提交
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/v1/xiansuoRecord/' + props.detailData.id,
                    method: 'put',
                    data: formData
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/xiansuoRecord',
                    method: 'post',
                    data: Object.assign({ su_id: props.detailData.su_id }, formData)
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
const cancel = () => {
    emit('cancel')
}
const handleChat = () => {
    let requestParam = {
        url: '/admin/v1/xiansuo/chat',
        method: 'post',
        data: { id: props.detailData.su_id }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
</script>

<style lang="less" scoped></style>
